import { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

const ErrorText = ({ children, className }: ComponentProps<'p'>) => {
  return <p className={twMerge('text-sm font-normal text-ph-red', className)}>{children}</p>;
};

export default ErrorText;
